var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container-image",style:(_vm.styles)},[_c('span',[_vm._v(_vm._s(_vm.letters))])])}
var staticRenderFns = []

export { render, staticRenderFns }